<template>
    <b-button-group style="margin-bottom: 5px;">
        <b-button-group class="mr-1">
            <b-button @click="karakterYaz('â')">â</b-button>
            <b-button @click="karakterYaz('ā')">ā</b-button>
            <span style="margin: 3px"/>
            <b-button @click="karakterYaz('î')">î</b-button>
            <b-button @click="karakterYaz('ī')">ī</b-button>
            <span style="margin: 3px"/>
            <b-button @click="karakterYaz('û')">û</b-button>
            <b-button @click="karakterYaz('ū')">ū</b-button>
            <span style="margin: 3px"/>
            <b-button @click="karakterYaz('ʻ')">ʻ (Ayn)</b-button>
            <b-button @click="karakterYaz('ʼ')">ʼ (Hemze)</b-button>
            <span style="margin: 3px" @click="latinceOsmanlicayaGit"/>
            <b-button style="float:right;" @click="latinceOsmanlicayaGit">
                <b-icon icon="arrow-up-right"></b-icon>
            </b-button>
        </b-button-group>
    </b-button-group>
</template>

<script>
    export default {
        name: "imla",
        methods: {
            karakterYaz(karakter) {
                this.$emit('karakter-yaz', karakter)
            },
            latinceOsmanlicayaGit() {
                let routeData = this.$router.resolve({name: 'latinceosmanlica'});
                window.open(routeData.href, '_blank');
            }
        }
    }
</script>

<style scoped>

</style>
